import React, { useState } from "react";
import BTNTabsIndicators from "./BTNTabsIndicators";
import BTNArrows from "./BTNArrows";
import CarrouselStyle from "./style.module.scss";
import CarouselMoveTimeout from "Componentes/CarouselFede/Helpers/CarouselMoveTimeout";
import CarouselItem, { CarouselItemProps } from "./CarouselItem";

type CarouselProps = {
  arrows?: boolean;
  indicators?: boolean;
  autoMove?: number;
  items: Array<CarouselItemProps>;
};

const Carousel: React.FC<CarouselProps> = ({
  arrows,
  indicators,
  autoMove,
  items
}) => {
  const [tab, setTab] = useState(0);
  const contChildrens = items.length;

  if (autoMove) {
    CarouselMoveTimeout({
      autoMove: autoMove,
      tab: tab,
      contChildrens: contChildrens,
      setTab: setTab
    });
  }

  return (
    <div
      title={autoMove ? "autoMove" : ""}
      className={`${CarrouselStyle.carousel} `}>
      {arrows ? (
        <BTNArrows tab={tab} setTab={setTab} contChildrens={contChildrens} />
      ) : null}
      {indicators ? (
        <BTNTabsIndicators
          tab={tab}
          setTab={setTab}
          contChildrens={contChildrens}
        />
      ) : null}

      {items.map((item, index) => (
        <CarouselItem
          tab={tab}
          key={index}
          index={index}
          titulo={item.titulo}
          description={item.description}
          image={item.image}
          column={item.column ? item.column : false}></CarouselItem>
      ))}
    </div>
  );
};

export default Carousel;
